import { useState } from "react";

import { FaCircleUser } from "react-icons/fa6";

import { useAppSelector } from "@/redux/store/hooks";
import { buildImgixUrl } from "@/lib";

interface AvatarProps {
  onClick?: () => void;
}

const UserAvatar = ({ onClick }: AvatarProps) => {
  const { imageUrl } = useAppSelector(
    (state) => state.user.registeredUser.profile
  );
  const [isImageError, updateImageError] = useState(false);

  // This function is triggered if an error occurs while loading an image
  const onImageError = () => {
    if (!isImageError) {
      updateImageError(true);
    }
  };

  return imageUrl && !isImageError ? (
    <img
      alt="avatar-img"
      src={buildImgixUrl(imageUrl)}
      onClick={onClick}
      className="avatar user-settings-avatar-small"
      onError={onImageError}
      data-testid="participant-header-user-avatar"
    />
  ) : (
    <span>
      <FaCircleUser
        size={38}
        onClick={onClick}
        className="avatar dummy-avatar-icon"
        data-testid="participant-header-user-avatar"
      />
    </span>
  );
};

export default UserAvatar;
